import _sfc_main from "./BuyBoxFavoriteButton2.mjs";
/* empty css                       */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxFavoriteButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-04b9733a"]]);
export {
  BuyBoxFavoriteButton as default
};
//# sourceMappingURL=BuyBoxFavoriteButton.mjs.map
